import * as React from 'react'
import { useState, useEffect } from 'react'
import { captureExceptionWithSentry } from '../sentry'
import GoogleSigninButton from '../common/googleLogin/GoogleSigninButton'
import MicrosoftSigninButton from '../common/microsoftLogin/MicrosoftSigninButton'
import { Row, Col } from 'react-bootstrap'
import { microsoftLoginSignupHandler, googleLoginSignupHandler } from '../common/GoogleMicrosoftApiCall'
import { useHistory } from 'react-router-dom'
import { CredentialResponse, TokenResponse } from '@react-oauth/google'

interface UserInfo {
	username?: string
	password?: string
}

const LoginForm = () => {
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState(false)
	const [errMsg, setErrMsg] = useState('')
	const history = useHistory()
	const [msClientId, setMsClientId] = useState('')
	const [googleClientId, setGoogleClientId] = useState('')

	useEffect(() => {
		const root = document.getElementById('root')
		if (root) {
			const msId = root.getAttribute('data-ms-id') ?? ''
			const gid = root.getAttribute('data-google-id') ?? ''
			setMsClientId(msId)
			setGoogleClientId(gid)
		}
	}, [])

	const logoStyle = {
		background: "url('/images/readpeak_logo_white.svg')",
		backgroundRepeat: 'no-repeat',
		height: '200px',
		width: '100%',
		marginBottom: '-30px',
		marginLeft: '-70px',
	}

	const orTextStyle: React.CSSProperties = {
		marginBottom: '-15px',
		marginTop: '20px',
		textAlign: 'center',
		color: 'white',
		font: 'normal normal 17px/30px Raleway',
	}

	const handleSubmit = async () => {
		const user: UserInfo = {}
		user.username = username
		user.password = password
		try {
			const resp = await fetch('/users/newlogin', {
				credentials: 'same-origin',
				body: JSON.stringify({ User: user }),
				headers: {
					Accept: 'application/json',
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'Content-Type': 'application/json',
				},
				method: 'POST',
			})
			if (resp.ok && (resp.status === 200 || resp.status === 302)) {
				window.location.href = '/dashboard?lgn=1'
				return
			} else {
				setError(true)
				setErrMsg('Incorrect email or password. Please use your email address as the username')
			}
		} catch (err) {
			setError(true)
			setErrMsg('Incorrect email or password. Please use your email address as the username')
			captureExceptionWithSentry(err)
		}
	}

	const microsoftLogin = async () => {
		try {
			const { result } = await microsoftLoginSignupHandler(msClientId)
			if (result.status === 'OK' && !result.data) {
				window.location.href = '/dashboard?lgn=1'
			} else if (result.status === 'OK' && result.data) {
				setError(true)
				setErrMsg('User not found')
				history.push('/login')
			} else if (result.status === 'error') {
				setError(true)
				setErrMsg('Something went wrong while login with Microsoft')
			}
		} catch (err) {
			setError(true)
			setErrMsg('Something went wrong while login with Microsoft')
			captureExceptionWithSentry(err)
		}
	}

	const googleLogin = async (response: CredentialResponse | TokenResponse) => {
		try {
			const json = await googleLoginSignupHandler(response)
			if (json.status === 'OK' && !json.data) {
				window.location.href = '/dashboard?lgn=1'
			} else if (json.status === 'OK' && json.data) {
				setError(true)
				setErrMsg('User not found')
				history.push('/login')
			} else if (json.status === 'error') {
				setError(true)
				setErrMsg('Something went wrong while login with Microsoft')
			}
		} catch (err) {
			setError(true)
			setErrMsg('Something went wrong while login with Google')
			captureExceptionWithSentry(err)
		}
	}

	return (
		<div className="new-login-form form-container mt-40" id="new-login-form">
			<div className="logo" style={logoStyle}></div>
			<div className="loginbuttons">
				{msClientId && (
					<MicrosoftSigninButton
						microsoftLogin={microsoftLogin}
						text="Sign in with Microsoft"
						width="310px"
					/>
				)}
				{googleClientId && msClientId && (
					<>
						<GoogleSigninButton
							clientId={googleClientId}
							googleLogin={googleLogin}
							text="signin_with"
							width="310"
						/>

						<Row>
							<Col xs={12} style={orTextStyle}>
								<b>OR</b>
							</Col>
						</Row>
					</>
				)}
			</div>
			{error && (
				<div className="alert alert-danger">
					<button className="close" data-close="alert"></button>
					<span>
						{error && errMsg
							? errMsg
							: 'Incorrect email or password. Please use your email address as the username'}
					</span>
				</div>
			)}
			<div className="form-group input-thing">
				<label htmlFor="exampleInputEmail1" className="form-label">
					Work Email Address
				</label>
				<div className="input-container">
					<i className="fa fa-user icon"></i>
					<input
						type="text"
						className="form-control input-width no-border"
						id="exampleInputEmail1"
						onChange={(e: React.FormEvent<HTMLInputElement> & { target: HTMLInputElement }) =>
							setUsername(e.target.value)
						}
						placeholder="E-mail Address"
						required
					/>
				</div>
			</div>
			<div className="form-group input-thing">
				<label htmlFor="exampleInputPassword1" className="form-label">
					Password
				</label>
				<div className="input-container">
					<i className="fa fa-lock icon" aria-hidden="true"></i>
					<input
						type="password"
						className="form-control input-width no-border"
						id="exampleInputPassword1"
						onChange={(e: React.FormEvent<HTMLInputElement> & { target: HTMLInputElement }) =>
							setPassword(e.target.value)
						}
						placeholder="Password"
						required
					/>
				</div>
			</div>
			<button className="btn btn-primary login-btn" onClick={handleSubmit}>
				LOGIN{' '}
				<span className="ml-5">
					<i className="fa fa-sign-in" aria-hidden="true"></i>
				</span>
			</button>
		</div>
	)
}
export default LoginForm
